var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("备案号：闽ICP备2024047964号-1")]),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v("厦门佰小轩数字教育科技有限公司")])])
}]

export { render, staticRenderFns }